/**
 * coach-gateway.js
 * Submits coach prompts via fetch/FormData.
 */

import { resolveFetch, submitFormRequest } from './form-submit.js';

function inferApiBase() {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }
  const host = window.location && window.location.hostname ? window.location.hostname : 'localhost';
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return isLocal ? 'http://' + host + ':3001' : 'https://api.agilepro.ai';
}

function normaliseAttachments(list = []) {
  if (!Array.isArray(list)) {
    return list ? [list] : [];
  }
  return list.filter((file) => file != null);
}

export class CoachGateway {
  constructor({ fetch, apiBase = null } = {}) {
    const fetchImpl = resolveFetch(fetch);
    if (!fetchImpl) {
      throw new Error('CoachGateway requires a fetch implementation');
    }
    this.fetch = fetchImpl;
    this.apiBase = apiBase || inferApiBase();
  }

  async submit({
    persona,
    lens,
    teamId,
    scopeId = null,
    teamName,
    precisionPrompt,
    originalMessage,
    attachments = [],
    useIntelligenceContext = false,
  } = {}) {
    const teamField =
      typeof teamName === 'string' && teamName.trim()
        ? teamName.trim()
        : '';

    return submitFormRequest({
      fetch: this.fetch,
      url: this.apiBase + '/api/coach',
      fields: {
        persona,
        lens,
        // The name is what the prompt uses; the id is what the organizational
        // scope is found by, and it never reaches a model.
        teamId: teamId || '',
        // An ART: the subject is a scope. Like the team id, it never reaches a model.
        scopeId: scopeId || '',
        team: teamField,
        message: precisionPrompt,
        originalMessage,
        notes: '',
        useIntelligenceContext: useIntelligenceContext === true ? 'true' : 'false',
      },
      files: normaliseAttachments(attachments),
    });
  }
}

if (typeof window !== 'undefined') {
  window.AgileProGateways = window.AgileProGateways || {};
  window.AgileProGateways.CoachGateway = CoachGateway;
}
